/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase,
    rowSpacing,
    fontSize,
    fontSizeDesktop,
    enterpriseCSS,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const TrackOrderStyle = (typography, palette) => ({
    TrackOrderStyle: {
        // Delivery Hours
        '& .deliveryHours': {
            border: `2px solid ${palette.grey7}`,
            borderRadius: '4px',
            padding: `${unitBase * 2}px`,
            display: 'flex',
            alignItems: 'center',
            fontSize: fontSize.small,
            justifyContent: 'space-between',
            '& svg': {
                paddingRight: unitBase,
            },
            '& .deliveryLabel': {
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
                fontWeight: 700,
                color: palette.grey4,
                '& svg': {
                    verticalAlign: 'middle',
                    width: '24px',
                },
            },
            '& > div': {
                '& > div': {
                    display: 'inline-block',
                    lineHeight: '16px',
                },
                '& > svg': {
                    color: palette.grey6,
                    width: '16px',
                },
            },
        },

        '& .desktop-no-orders': {
            fontWeight: 700,
            textAlign: 'center',
            marginTop: rowSpacing * 2,
        },

        '& .back-to-top-wrapper': {
            display: 'block',
            textAlign: 'center',
            margin: `${rowSpacing * 2}px 0`,
        },

        '& .add-to-cart-error': {
            border: `1px solid ${enterpriseCSS.palette.buyAgain.stockErrorBackground}`,
            background: enterpriseCSS.palette.buyAgain.stockErrorBackground,
            color: enterpriseCSS.palette.white,
            padding: '7px',
            textAlign: 'center',
            margin: '0px 0px 12px 0px',
            fontSize: '15px !important',
        },

        '& .back-to-top-link': {
            color: enterpriseCSS.palette.blue,
            fontWeight: 700,
            fontSize: fontSizeDesktop.small,
            textDecoration: 'none',
            position: 'relative',
            padding: 0,
            paddingRight: rowSpacing * 2,
            border: 0,
            background: 'transparent',
            '& > svg': {
                position: 'absolute',
                right: 0,
                bottom: '-5px',
            },
        },

        // OrderList Item
        '& .orderListItem': {
            margin: `${rowSpacing}px -${rowSpacing}px`,
            borderTop: `1px solid ${enterpriseCSS.palette.gray2}`,
            padding: rowSpacing,

            '&.last': {
                paddingBottom: `${rowSpacing * 2}px`,
                borderBottom: `1px solid ${enterpriseCSS.palette.gray2}`,
            },
            '& .orderListHeader': {
                background: enterpriseCSS.palette.gray3,
                padding: '10px 12px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',

                '& button': {
                    minWidth: 'auto',
                    padding: '6px 12px',
                },
            },
            '& .orderInfo': {
                '& > *': {
                    marginBottom: `${rowSpacing}px`,
                    '&.orderDetail': {
                        whiteSpace: 'nowrap',
                    },
                },
                '& .orderDetailMargin': {
                    marginBottom: '0px',
                },
            },

            '& .orderListProduct': {
                padding: rowSpacing,
                '&::after': {
                    content: '""',
                    display: 'block',
                    borderBottom: `2px dashed ${enterpriseCSS.palette.gray3}`,
                    width: '90%',
                    margin: '0 auto',
                    paddingBottom: `${rowSpacing * 2}px`,
                },
                '&:last-child::after': {
                    borderBottom: 'none',
                    margin: 0,
                    padding: 0,
                },
                '& .productName': {
                    fontSize: '16px',
                },
            },
            '& .delay-container': {
                display: 'flex',
                alignItems: 'center',
                '& img': {
                    marginRight: '5px',
                },
            },
            '& .productImg > img': {
                width: '100%',
                height: 'auto',
            },
        },

        // Status tracking bar
        ...StatusTrackingBar(typography, palette).StatusTrackingBar,
    },
});
